import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { StringObj } from "../../../../../../../type";
import { DndContext, closestCenter, DragEndEvent } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { QuestionsContext } from "../../../../../../../provider/MyContexts";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { AiCommands } from "./OptionArea";
import { ClearButton } from "../../../../../components/MyIconButton";

type Props = {
  onChange: (options: object[]) => void;
  handleDelete: (index: number) => void;
};

function SortableItem({ item, index }: { item: StringObj; index: number }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const { updateMatrixValue } = useContext(QuestionsContext);

  const [text, setText] = useState<string>("");

  function handleChangeText(e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    e.stopPropagation();
    setText(e.target.value);
  }

  useEffect(() => {
    setText(item.text);
  }, [item.text]);

  return (
    <Stack ref={setNodeRef} style={style} marginX={0.5} flex={1}>
      <Stack
        direction={"row"}
        spacing={0.5}
        alignItems={"center"}
        justifyContent={"center"}
        marginY={0.5}
        padding={0.25}
        sx={{
          border: "1px solid transparent",
          ":hover": {
            border: "1px solid #333",
            borderRadius: 1,
          },
        }}
        // {...attributes}
        // {...listeners}
        flex={1}
      >
        <div {...attributes} {...listeners} style={{ cursor: "grab" }}>
          <DragHandleIcon fontSize="small" />
        </div>
        <TextField
          value={text}
          label={`${index + 1}`}
          size="small"
          sx={{ flex: 1 }}
          onChange={handleChangeText}
          onBlur={(e) => {
            e.preventDefault();
            e.stopPropagation();
            updateMatrixValue(item.itemId, text, "text");
          }}
        />
      </Stack>
    </Stack>
  );
}

export default function SortableMartix(props: Props) {
  const { onChange, handleDelete } = props;

  const { selectedQuestion } = useContext(QuestionsContext);

  const loops = selectedQuestion.loop as any[];

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = loopItems.findIndex((item) => item.id === active.id);
    const newIndex = loopItems.findIndex((item) => item.id === over.id);
    const reordered = arrayMove(loopItems, oldIndex, newIndex);
    onChange(reordered);
  };

  const handleAdd = () => {
    onChange([
      ...loopItems,
      {
        itemId: (loopItems.length + 1).toString(),
        text: "",
        answerType: "",
        exclusive: "",
        condition: "",
        random: "",
        creative: "",
        remarks: "",
      },
    ]);
  };
  // const optionItems = options.map((value, index) => ({
  //   id: `${value}-${index}`, // ユニークID（valueが""や重複してもOK）
  //   value,
  // }));

  const loopItems = loops.map((loop, index) => {
    return {
      ...loop,
      id: `${loop.text}-${index}`, // ユニークID
    };
  });

  return (
    <Stack>
      <Typography variant="heading_XS" fontWeight={600} marginBottom={1}>
        表側・行項目
      </Typography>
      <AiCommands handleAdd={handleAdd} area={"matrix"} />

      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext
          strategy={verticalListSortingStrategy}
          items={loopItems.map((item) => item.id)}
        >
          <Stack width={"100%"}>
            {loopItems.map((item, index) => {
              return (
                <Stack
                  marginX={1}
                  direction={"row"}
                  spacing={0.2}
                  key={item.id}
                  alignItems={"center"}
                  justifyContent={"center"}
                  width={"100%"}
                >
                  <SortableItem key={item.id} item={item} index={index} />

                  {selectedQuestion.questionType.includes("混合") && (
                    <FormControl sx={{ width: 80 }} size="small">
                      <InputLabel id="qType-select-label">回答形式</InputLabel>
                      <Select
                        labelId="qType-select-label"
                        id="qType-select"
                        value={item.answerType}
                        // onChange={(e) => handleChangeQuestionType(e.target.value)}
                        size="small"
                        label={"回答形式"}
                      >
                        {["SA", "MA"].map((elm, index) => (
                          <MenuItem key={index} value={elm}>{`${elm}`}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  <TextField
                    value={item.condition || "ALL"}
                    // onChange={handleConditionChange}
                    // onBlur={() => syncState("condition")}
                    disabled={true}
                    label={"表示条件"}
                    sx={{ maxWidth: 160 }}
                    size="small"
                  />
                  <ClearButton onClick={() => handleDelete(index)} />
                </Stack>
              );
            })}
            {/* <Stack
              direction={"column"}
              spacing={2}
              alignItems={"center"}
              justifyContent={"center"}
              marginY={1}
            >
              <Button variant="text" size="small" onClick={handleAdd}>
                <Typography variant="body_S">追加</Typography>
              </Button>
            </Stack> */}
          </Stack>
        </SortableContext>
      </DndContext>
    </Stack>
  );
}
